// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeResponseModel {
    static getAttributeTypeMap() {
        return SimpleIntakeResponseModel.attributeTypeMap;
    }
}
SimpleIntakeResponseModel.discriminator = undefined;
SimpleIntakeResponseModel.additionalProperties = false;
SimpleIntakeResponseModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "displayId",
        "baseName": "displayId",
        "type": "string"
    },
    {
        "name": "workflowIds",
        "baseName": "workflowIds",
        "type": ""
    },
];
//# sourceMappingURL=simpleIntakeResponseModel.js.map